import { Button, Modal } from "semantic-ui-react";
import { M11Step001ValidationCheck } from "./M11Step001SponsorDetails";
import { M11Step002ValidationCheck } from "./M11Step002Identifiers";
import { M11Step003ValidationCheck } from "./M11Step003TitlePageData";
import { M11Step006EligibilityValidationCheck } from "./M11Step006Eligibility";
import { M11Step008FirstObjectiveValidationCheck } from "./M11Step008FirstPrimaryObjective";
import { M11Step011ExploratoryObjectivesValidationCheck } from "./M11Step011ExploratoryObjectives";
import { M11Step013EnterOverallDesignValidationCheck } from "./M11Step013EnterOverallDesignData";
import { M11Step014EnterOverallDesignValidationCheck } from "./M11Step014EnterOverallDesignData2";
import { M11Step004AmendmentValidationCheck } from "./M11Step004Amendment";
import { M11Step005TitlePageValidationCheck } from "./M11Step005CreateTitlePage";
import { M11Step015ProtocolSynopsisObjectivesValidationCheck } from "./M11Step015ProtocolSynopsisObjectives";
import { M11Step016OverallDesignValidationCheck } from "./M11Step016OverallDesign";
import { M11Step017ProtocolSynopsisValidationCheck } from "./M11Step017ProtocolSynopsis";
import { M11Step018ProtocolSummaryValidationCheck } from "./M11Step018ProtocolSummary";
import { M11Step019IntroductionValidationCheck } from "./M11Step019Introduction";
import { M11Step012Section3ValidationCheck } from "./M11Step012ObjectivesAndEstimands";
import { M11Step020TrialDesignValidationCheck } from "./M11Step020TrialDesign";
import { M11Step007TrialPopulationValidationCheck } from "./M11Step007TrialPopulation";
import { M11Step021TrialInterventionPart1ValidationCheck } from "./M11Step021TrialInterventionPart1";
import { M11Step022TrialInterventionPart2ValidationCheck } from "./M11Step022TrialInterventionPart2";
import { M11Step023TrialInterventionPart3ValidationCheck } from "./M11Step023TrialInterventionPart3";
import { M11Step024TrialInterventionPart4ValidationCheck } from "./M11Step024TrialInterventionPart4";
import { M11Step025TrialInterventionPart5ValidationCheck } from "./M11Step025TrialInterventionPart5";
import { M11Step026ParticipantDiscontinuationValidationCheck } from "./M11Step026ParticipantDiscontinuation";
import { M11Step027TrialAssessmentsPart1ValidationCheck } from "./M11Step027TrialAssessmentsPart1";
import { M11Step028TrialAssessmentsPart21ValidationCheck } from "./M11Step028TrialAssessmentsPart2";
import { M11Step029TrialAssessmentsPart3ValidationCheck } from "./M11Step029TrialAssessmentsPart3";
import { M11Step030AdverseEventsDefinitionsValidationCheck } from "./M11Step030AdverseEventsDefinitions";
import { M11Step031AdverseEventsProceduresValidationCheck } from "./M11Step031AdverseEventsProcedures";
import { M11Step032CompleteAdverseEventsValidationCheck } from "./M11Step032CompleteAdverseEvents";
import { M11Step033StatisticsPart1ValidationCheck } from "./M11Step033StatisticsPart1";
import { M11Step010SecondaryObjectivesValidationCheckk } from "./M11Step010SecondaryObjectives";
import { M11Step034CompleteStatisticsValidationCheck } from "./M11Step034CompleteStatistics";
import { M11Step035TrialOversightPart1ValidationCheck } from "./M11Step035TrialOversightPart1";
import { M11Step036TrialOversightPart2ValidationCheck } from "./M11Step036TrialOversightPart2";
import { M11Step037CompleteTrialOversightValidationCheck } from "./M11Step037CompleteTrialOversight";
import { M11Step038GatherAppendicesValidationCheck } from "./M11Step038GatherAppendices";
import { M11Step039GlossaryValidationCheck } from "./M11Step039Glossary";
import { M11Step040ReferencesValidationCheck } from "./M11Step040References";
import { M11Step041SupportingDetailsPart1ValidationCheck } from "./M11Step041SupportingDetailsPart1";
import { M11Step042PriorProtocolAmendmentsValidationCheck } from "./M11Step042PriorProtocolAmendments";
import { M11Step043AdditionalAppendicesValidationCheck } from "./M11Step043AddittionalAppendices";
import { M11Step009OtherPrimaryObjectivesValidationCheck } from "./M11Step009OtherPrimaryObjectives";


const validationChecks = [
    M11Step001ValidationCheck,
    M11Step002ValidationCheck,
    M11Step003ValidationCheck,
    M11Step004AmendmentValidationCheck,
    M11Step005TitlePageValidationCheck,
    M11Step006EligibilityValidationCheck,
    M11Step007TrialPopulationValidationCheck,
    M11Step008FirstObjectiveValidationCheck,
    M11Step009OtherPrimaryObjectivesValidationCheck,
    M11Step010SecondaryObjectivesValidationCheckk,
    M11Step011ExploratoryObjectivesValidationCheck,
    M11Step012Section3ValidationCheck,
    M11Step013EnterOverallDesignValidationCheck,
    M11Step014EnterOverallDesignValidationCheck,
    M11Step015ProtocolSynopsisObjectivesValidationCheck,
    M11Step016OverallDesignValidationCheck,
    M11Step017ProtocolSynopsisValidationCheck,
    M11Step018ProtocolSummaryValidationCheck,
    M11Step019IntroductionValidationCheck,
    M11Step020TrialDesignValidationCheck,
    M11Step021TrialInterventionPart1ValidationCheck,
    M11Step022TrialInterventionPart2ValidationCheck,
    M11Step023TrialInterventionPart3ValidationCheck,
    M11Step024TrialInterventionPart4ValidationCheck,
    M11Step025TrialInterventionPart5ValidationCheck,
    M11Step026ParticipantDiscontinuationValidationCheck,
    M11Step027TrialAssessmentsPart1ValidationCheck,
    M11Step028TrialAssessmentsPart21ValidationCheck,
    M11Step029TrialAssessmentsPart3ValidationCheck,
    M11Step030AdverseEventsDefinitionsValidationCheck,
    M11Step031AdverseEventsProceduresValidationCheck,
    M11Step032CompleteAdverseEventsValidationCheck,
    M11Step033StatisticsPart1ValidationCheck,
    M11Step034CompleteStatisticsValidationCheck,
    M11Step035TrialOversightPart1ValidationCheck,
    M11Step036TrialOversightPart2ValidationCheck,
    M11Step037CompleteTrialOversightValidationCheck,
    M11Step038GatherAppendicesValidationCheck,
    M11Step039GlossaryValidationCheck,
    M11Step040ReferencesValidationCheck,
    M11Step041SupportingDetailsPart1ValidationCheck,
    M11Step042PriorProtocolAmendmentsValidationCheck,
    M11Step043AdditionalAppendicesValidationCheck
];

const M11ValidationModal = ({ openM11ValidationModalState, setOpenM11ValidationModalState, stepCount, theM11ResearchStudyFoi }) => {

    const ActiveValidationCheck = validationChecks[stepCount - 1];

    return <Modal
        style={{ width: "50%", margin: "16px" }}
        dimmer={<Modal.Dimmer blurring style={{ backgroundColor: "#00000077" }} />}
        open={openM11ValidationModalState}
        closeOnEscape
        closeOnDimmerClick
        onClose={() => setOpenM11ValidationModalState(false)}
        centered={false}
        content={<div style={{ whiteSpace: "pre-wrap" }}>
            <Button className="formButton negative"
                style={{ padding: "6px", position: "absolute", top: "6px", right: "6px", zIndex: 10 }} content="✖" title="Close"
                onClick={() => { setOpenM11ValidationModalState(false); }}
            />
            <Modal.Header style={{ padding: "6px 16px 0px 16px", color: "#AC3B61", textAlign: "center" }}>
                <h2>M11 Report Validation Check</h2>
            </Modal.Header>
            <br />
            <div style={{ padding: "0px 16px 0px 16px" }}>
                <h3>FOI {theM11ResearchStudyFoi}{stepCount && " Validation Check for Step " + stepCount}</h3>
                <br />
                <br />
                {ActiveValidationCheck && <ActiveValidationCheck />}
                {stepCount === 44 && <p>Step {stepCount} does not use the Validation Modal.</p>}
                {stepCount === 45 && <p>Step {stepCount} does not use the Validation Modal.</p>}
                {stepCount > 45 && <p>There are only 45 steps.</p>}
                <br />
                <br />
                <div style={{ width: "100%", textAlign: "center" }}>
                    <Button className="formButton"
                        style={{ padding: "6px", width: "150px" }}
                        content={"Close"}
                        onClick={() => {
                            setOpenM11ValidationModalState(false);
                        }}
                    />
                </div>
                <br />
            </div>
        </div>}
    />
}

export default M11ValidationModal;